<app-tabs-group [tabWidth]="'230px'">
    <!-- Tab Overview -->
    <app-tab [icon]="'monitor'" label="{{ 'page.agent.workstations.tab' | translate }}" labelSuffix="{{ (agentStatistics?.workstationAgentCount || 0) }}" >
        <div class="mt-l flex-column ml-s">
            <div class="live-indicator">
                <span class="dot"></span>
                <span class="live-text">{{ 'page.agent.workstations.updateIndicator' | translate }}</span>
            </div>
            <div class="font-S grey">{{ 'page.agent.workstations.lastUpdateIndicator' | translate }} {{ timeSinceLastUpdate }} </div>
        </div>

        <div class="main-container pt-xl pb-l gap-L">
            <div #leftColumn class="disp-f f-d-col gap-L overflow-hidden left-extension-panel">
                <div class="widget purple pad-XL grid-4">
                    <div class="span3 grid-3 auto-layout gap-S">
                        <div class="flex-align-center" style="position: relative;">
                            <span *ngIf="adviceMessage.version" class="message-badge"><img src="assets/icons/message-star.svg" height="14" width="14"></span>

                            <div class="main-icon flex-align-center flex-justify-center">
                                <img class="filter-grey" src="assets/icons/satellite.svg" height="35" width="35" alt="">
                            </div>
                        </div>

                        <div class="flex-column flex-justify-center">
                            <div>{{adviceMessage.message}}</div>
                            <div *ngIf="adviceMessage.version" class="purple">{{ adviceMessage.version }}</div>
                        </div>
                    </div>
                    <div class="grid gap-S">
                        <div>
                            <app-text-button size="compact"  (click)="onOpenDownloadPage()" [color]="'accent-secondary'" type="flat">
                                <span class="pad-left-XS"> {{ 'page.agent.workstations.downloadPackageButton' | translate }} </span>
                            </app-text-button>
                        </div>
                        <div>
                            <app-text-button size="compact" (click)="onDisplayDocumentation()" [color]="'accent-secondary'" type="stroked">
                                <img ngSrc="assets/icons/info-black.svg" alt="Documentation" width="20" height="20"/>
                                <span class="pad-left-XS">{{ 'page.agent.workstations.openDocumentationButton' | translate }}</span>
                            </app-text-button>
                        </div>
                    </div>
                </div>
                <div class="widget" >
                    <app-agents-deployment-graph [height]="180" [displayRange]="true" [widgetTitle]="'page.agent.workstations.chartWidgetName'|translate"></app-agents-deployment-graph>
                </div>
                <div class="widget" >
                    <app-agents-versions></app-agents-versions>
                </div>
            </div>
            <div [style.height]="columnHeight" class="widget">
                <app-snackbar></app-snackbar>
                <app-agent-list [height]="tableHeight"></app-agent-list>
            </div>
        </div>
    </app-tab>

    <app-tab-button (click)="onOpenWorkstationSettings()">
        <div class="flex-align-center gap-S">
            <img ngSrc="assets/icons/settings-2.svg" alt="Open settings" height="14" width="14">
            <div>{{ 'page.agent.workstations.openSettings' | translate }}</div>
            <img ngSrc="assets/icons/arrow-right-black.svg" alt="Open settings" height="10" width="6">
        </div>
    </app-tab-button>
</app-tabs-group>
